import styled from 'styled-components';

export const RenderItem = styled.span`
  white-space: nowrap;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${({ bgColor }) => bgColor};
  color: white;
`;